import React, { useCallback, useMemo } from 'react';
import { StyleSheet } from 'react-native';
import Text from 'design-system/Text';
import { hitSlop } from 'design-system/values';
import useEnergyCompare, { mapMerchantTypeToCompareType, } from 'features/feed/components/save/useEnergyCompare';
import { selectFeatureFlag } from 'reducers/selectors';
import { useAppSelector } from 'store/hooks';
import TouchableBounce from 'utils/packages/TouchableBounce';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { selectShouldShowSwitchSuggestions } from '../selectors';
import { isWeb } from '../../../constants';
const strings = {
    GAS_AND_ELECTRICITY: 'Save on energy',
    BROADBAND: 'Save on broadband',
};
const SwitchSuggestionLabel = ({ account }) => {
    const navigation = useMainStackNavigation();
    const shouldShow = useAppSelector(selectShouldShowSwitchSuggestions);
    const showEnergySwitch = useAppSelector((store) => selectFeatureFlag(store, 'energy_switch_two').value);
    const guessedHomeCountry = useAppSelector((store) => store.user.user.guessedHomeCountry);
    const merchantType = account.suggestSwitch?.merchantType;
    const onOpenCompare = useCallback((routeWithParams) => {
        navigation.navigateDeprecated(routeWithParams);
    }, [navigation]);
    const compare = useEnergyCompare(onOpenCompare);
    const onPress = useCallback(() => {
        if (!merchantType)
            return;
        compare(mapMerchantTypeToCompareType(merchantType));
    }, [compare, merchantType]);
    const label = useMemo(() => {
        if (!merchantType || account.isClosed)
            return null;
        if (guessedHomeCountry !== 'GB')
            return null;
        if (merchantType === 'GAS_AND_ELECTRICITY' && !showEnergySwitch)
            return null;
        return strings[merchantType];
    }, [account.isClosed, guessedHomeCountry, merchantType, showEnergySwitch]);
    if (!shouldShow || !label || isWeb)
        return null;
    return (<TouchableBounce onPress={onPress} hitSlop={hitSlop} style={staticStyles.touchable}>
      <Text TextThin-14 Primary>
        {label}
      </Text>
    </TouchableBounce>);
};
const staticStyles = StyleSheet.create({
    touchable: {
        alignSelf: 'flex-start',
    },
});
export default React.memo(SwitchSuggestionLabel);
